<template>
  <div class="flex flex-col gap-4">
    <div class="rounded-lg border bg-card p-6">
      <div class="flex flex-col gap-3">
        <h2 class="text-lg font-semibold">
          Tasks
        </h2>
        <p class="text-sm text-muted-foreground">
          Select a context to load the matching task list.
        </p>
        <TaskListContextSwitcher v-model="selectedContext" :options="contextOptionsWithCounts" />
      </div>
    </div>

    <TasksList :key="selectedContext" :context="selectedContext" />
  </div>
</template>

<script setup>
import axios from 'axios'
import { computed, onMounted, ref } from 'vue'
import TaskListContextSwitcher from '../../components/tasks/TaskListContextSwitcher.vue'
import { getTaskListRouteContext, TASK_LIST_CONTEXT_OPTIONS } from '../../config/taskListConfig.js'
import TasksList from '../../components/tasks/TasksList.vue'

const contextOptions = TASK_LIST_CONTEXT_OPTIONS
const contextCounts = ref({})

const selectedContext = ref(contextOptions[0]?.value ?? 'my_active_tasks')

const contextOptionsWithCounts = computed(() => {
  return contextOptions.map((contextOption) => {
    const routeContext = getTaskListRouteContext(contextOption.value)

    return {
      ...contextOption,
      count: contextCounts.value[routeContext],
    }
  })
})

const fetchContextCounts = async () => {
  const contexts = contextOptions.map((contextOption) => getTaskListRouteContext(contextOption.value))
  const { data } = await axios.get('/api/v1/task-list-counts', {
    params: {
      contexts,
    },
  })

  contextCounts.value = data
}

onMounted(async () => {
  await fetchContextCounts()
})
</script>
